import { render, staticRenderFns } from "./CitizenshipChart.vue?vue&type=template&id=0709630f&"
import script from "./CitizenshipChart.vue?vue&type=script&lang=js&"
export * from "./CitizenshipChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports